import { combineReducers } from "redux";
import { objectsSlice } from "../app/reduxSlices/objectsSlice";

export const dormReducer = combineReducers({

    facility: objectsSlice({ name: "facility" }).reducer,
    roomFacility: objectsSlice({ name: "roomFacility" }).reducer,
    roomFacility_selectedFacility: objectsSlice({ name: "roomFacility_selectedFacility" }).reducer,


    subGroupDeviceSDormPermissions: objectsSlice({ name: "subGroupDeviceSDormPermissions" }).reducer,
    dormTrafficsReport: objectsSlice({ name: "dormTrafficsReport" }).reducer,
    myDormTrafficsReport: objectsSlice({ name: "myDormTrafficsReport" }).reducer,
    dormitoryTraffics: objectsSlice({ name: "dormitoryTraffics" }).reducer,
    myDormitoryTraffics: objectsSlice({ name: "myDormitoryTraffics" }).reducer,
    trafficTypes: objectsSlice({ name: "trafficTypes" }).reducer,
    userTrafficTypes: objectsSlice({ name: "userTrafficTypes" }).reducer,
    missionTrafficTypes: objectsSlice({ name: "missionTrafficTypes" }).reducer,

    bankAccountDorms: objectsSlice({ name: "bankAccountDorms" }).reducer,
    reservationTimeSettings: objectsSlice({ name: "reservationTimeSettings" }).reducer,
    reservationTimeSubGroup: objectsSlice({ name: "reservationTimeSubGroup" }).reducer,
    reservationTimeSubGroup_selectedSubGroups: objectsSlice({ name: "reservationTimeSubGroup_selectedSubGroups" }).reducer,

    dormTerms: objectsSlice({ name: "dormTerms" }).reducer,
    dormTermRooms: objectsSlice({ name: "dormTermRooms" }).reducer,
    dormTermRooms_selectedRooms: objectsSlice({ name: "dormTermRooms_selectedRooms" }).reducer,

    roomPricings: objectsSlice({ name: "roomPricings" }).reducer,
    roomReservations: objectsSlice({ name: "roomReservations" }).reducer,
    roomSwappings: objectsSlice({ name: "roomSwappings" }).reducer,
    dormManageReservations: objectsSlice({ name: "dormManageReservations" }).reducer,
    dormMyReservations: objectsSlice({ name: "dormMyReservations" }).reducer,

    roomStudents: objectsSlice({ name: "roomStudents" }).reducer,
    roomStatus: objectsSlice({ name: "roomStatus" }).reducer,

    dormPersonsReport: objectsSlice({ name: "dormPersonsReport" }).reducer,
    dormFinanciasReport: objectsSlice({ name: "dormFinanciasReport" }).reducer,
    roomReservationsReport: objectsSlice({ name: "roomReservationsReport" }).reducer,
    dormTransactionTypes: objectsSlice({ name: "dormTransactionTypes" }).reducer,

    preRegisterForm: objectsSlice({ name: "preRegisterForm" }).reducer,
    deviceDorms: objectsSlice({ name: "deviceDorms" }).reducer,
    dormSmsReport: objectsSlice({ name: "dormSmsReport" }).reducer,
    dormitorySmsConfigs: objectsSlice({ name: "dormitorySmsConfigs" }).reducer,
});

